import React, { useCallback, useMemo } from 'react';
import './LevelSwitch.scss';
import { SCENE_LIST_FLOOR_LEVELS } from 'consts/hardcoded-data';
import { useSelector } from 'react-redux';

export default function LevelSwitch({ currentPano, onSelect }) {
  const { scenes } = useSelector((state) => state);
  const enable = useMemo(() => {
    if (
      currentPano?._id &&
      SCENE_LIST_FLOOR_LEVELS.indexOf(currentPano?._id) !== -1
    ) {
      return true;
    }
    return false;
  }, [currentPano]);

  const isLevel = useCallback(
    (index) => {
      if (!enable) return false;
      return currentPano?._id === SCENE_LIST_FLOOR_LEVELS[index];
    },
    [currentPano, enable]
  );

  const goToLevel = useCallback(
    (index) => {
      const targetId = SCENE_LIST_FLOOR_LEVELS[index];
      const targetScene = scenes.find((scene) => scene._id === targetId);

      if (enable && currentPano?._id !== targetId) {
        onSelect('welcome', targetScene.id);
      }
    },
    [currentPano, onSelect, enable, scenes]
  );

  const floorLabels = useMemo(() => {
    const total = SCENE_LIST_FLOOR_LEVELS.length;
    if (total <= 1) return ['05'];
    const start = 5;
    const step = 5;
    return Array.from({ length: total }, (_, i) =>
      String(start + i * step).padStart(2, '0')
    );
  }, []);

  return (
    <>
      <div
        className={`level-switch-wp ${
          enable ? 'switch-enable' : 'switch-disable'
        }`}
      >
        <div className="level-switch">
          <div className="level-switch-text">TẦNG</div>
          {SCENE_LIST_FLOOR_LEVELS.map((_, index) => (
            <div
              key={SCENE_LIST_FLOOR_LEVELS[index]}
              className={`level-switch-item ${isLevel(index) && 'active'}`}
              onClick={() => goToLevel(index)}
            >
              {floorLabels[index]}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
